<section *ngIf="processing">
    <h2>{{processingMessage}}...</h2>
    <mat-progress-bar mode="indeterminate" color="warn" aria-label="processing...">
    </mat-progress-bar>
</section>

<section *ngIf="!processing">
    <!-- Action Buttons -->
    <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
        <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
            <h2 class="noMarginHeader"><mat-icon>note_add</mat-icon> Generate Voucher Letter {{voucher.voucherId}}</h2>
        </div>
        <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="end">
            <button type="submit" name="SubmitButton" (click)="onSubmitKendo()" mat-raised-button color="primary"
                value="Save" title="Save">Save</button>
            &nbsp;&nbsp;
            <button mat-button mat-dialog-close="Cancel" mat-raised-button color="basic"
                aria-label="Cancel">Cancel</button>
        </div>
    </div>
    <hr />
</section>

<mat-dialog-content id="voucherLetterPdf">
    <div class="print-outer" >
        <div class="print-inner">
          <kendo-pdf-export #pdf paperSize="letter" paperSize="A4" margin="2cm" [scale]="0.4" forcePageBreak=".page-break">
            <ng-container [ngTemplateOutlet]="kendoTemplate"
                          [ngTemplateOutletContext]="{export: true}">
                        </ng-container>
          </kendo-pdf-export>
          </div>
      </div>
      <ng-template #kendoTemplate let-export="export">
        <style>
        .english-text  {
          font-family:  'SpanishLatin',  'SpanishLatinBold'  ;
          font-size: 20pt;
      }
          kendo-pdf-export {
            font-family:  'SpanishLatin',  'SpanishLatinBold'  ;
              font-size: 20pt;
            }
        </style>
    <!-- English -->
    <section>
        <Header>
            <img src="{{environment.baseUrl}}/assets/images/OregonWell_Letterheader.png" alt="Letter Header" width="100%">
        </Header>
        <style>
            td,
            th {
                border: 1px solid #dddddd;
                margin-left: 5.4pt;
                padding: 0in 5.4pt 0in 5.4pt
            }
        </style>

        <body class="english-text">
            <p style='color:green; '>{{voucher?.applicantContactName}}<br>
                {{voucher?.applicantAddress}}<br>
                {{voucher?.applicantCity}} {{voucher?.applicantState}} {{voucher?.applicantZip}}</p>
            <p></p>
            <p></p>
            <p >Greetings <span
                    style='color:green;'>{{voucher?.applicantContactName}}</span></p>

            <p >This document contains your water treatment voucher and next steps.</p>

            <p ><strong>Find a licensed treatment specialist or plumber</strong><br>
                Choose a licensed treatment specialist or plumber from the following page of this letter. 
                Contact the treatment specialist and schedule your water treatment services.</p>

            <p >
                <strong>Present the voucher to the treatment specialist or plumber:</strong><br>
                The treatment specialist or plumber will install a certified reverse osmosis (RO) treatment system under 
                the kitchen sink to reduce nitrate levels below 10 milligrams per liter (mg/L).  </p>

            <p ><strong>Reminder:</strong> This voucher is not transferable. If you choose not
                to use the voucher, please contact us at <a
                    href="mailto:Domestic.Wells@odhsoha.oregon.gov"><u>Domestic.Wells@odhsoha.oregon.gov</u></a> or call 541-952-9254. </p>

            <p>

                <br>
                <strong>_ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _
                    <br>
                    <br>
                </strong>
            </p>
            <div style="page-break-before: always; " class="page-break">
                <strong >Voucher</strong>
                <table border=1 cellspacing=0 cellpadding=0 width=1100px
                    style='padding:0in 5.4pt 0in 5.4pt;margin-left:5.4pt;border-collapse:collapse;border:none;'
                    aria-describedby="voucher">
                    <tr>
                        <th scope="col" width=400px valign=top
                            style='border:solid black 1.0pt;background:black;padding:0in 5.4pt 0in 5.4pt;color:white;'>
                            Item</th>
                        <th scope="col" width=700px valign=top
                            style='border:solid black 1.0pt;border-left:none;background:black;padding:0in 5.4pt 0in 5.4pt;color:white;'>
                            Voucher Details</th>
                    </tr>
                    <tr>
                        <td style='padding:0in 5.4pt 0in 5.4pt;' width=400px>Client Name</td>
                        <td style='padding:0in 5.4pt 0in 5.4pt;color:green' width=700px><p>{{voucher?.applicantContactName}}</p></td>
                    </tr>
                    <tr>
                        <td style='padding:0in 5.4pt 0in 5.4pt;' width=400px>Voucher Number</td>
                        <td style='padding:0in 5.4pt 0in 5.4pt;color:green' width=700px><p>{{voucher?.voucherId}}</p></td>
                    </tr>
                    <tr>
                        <td style='padding:0in 5.4pt 0in 5.4pt;' width=400px>Applicant Address</td>
                        <td style='padding:0in 5.4pt 0in 5.4pt;color:green' width=700px>
                            <p>{{voucher?.applicantAddress}}<br>
                                {{voucher?.applicantCity}} {{voucher?.applicantState}} {{voucher?.applicantZip}}</p>
                        </td>
                    </tr>
                    <tr>
                        <td style='padding:0in 5.4pt 0in 5.4pt;' width=400px>Well Address<br>
                            <small>(If Different Than Mailing Address)</small>
                        </td>
                        <td style='padding:0in 5.4pt 0in 5.4pt;color:green' width=700px>
                            <p *ngIf="wellAddressDifferent">{{voucher?.well?.address1}}<br>
                                {{voucher?.well?.city}} {{voucher?.well?.state}} {{voucher?.well?.zip}}</p>
                        </td>
                    </tr>
                    <tr>
                        <td valign=top style='padding:0in 5.4pt 0in 5.4pt;' width=400px>Treatment items:</td>
                        <td style='padding:0in 5.4pt 0in 5.4pt;color:green' width=700px>
                            <p>
                            1 Nitrate reduction RO treatment system (certified), 2 replacement RO membranes, 2
                            replacement pre-filters,
                            2 replacement post-filters, 1 post-treatment nitrate test as needed: Pressure booster pump,
                            post nitrate
                            reduction filter, additional nitrate test (if post-nitrate reduction filter installed).<br/>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td style='padding:0in 5.4pt 0in 5.4pt;' width=400px>Total value not to exceed</td>
                        <td style='padding:0in 5.4pt 0in 5.4pt;' width=700px><strong><p>$2,950.00</p></strong></td>
                    </tr>
                </table>


                <br /><br />
                <span >&nbsp;&nbsp;Contracted Licensed Treatment Specialists and Plumbers</span>
                <br /> <br />
                <table border=1 cellspacing=0 cellpadding=0 width=1100px aria-describedby="accreditedLabs">
                    <tr style='height:15.0pt'>
                        <th scope="col" width=350px nowrap valign=top style='padding:0in 5.4pt 0in 5.4pt;width:161.75pt;height:15.0pt'>
                            <strong>Treatment Contractor Name</strong>
                        </th>
                        <th scope="col" width=400px ><strong>Address</strong></th>
                        <th scope="col" width=400px><strong>Phone</strong></th>
                    </tr>
                    <tr style='background-color: #F2F2F2;'>
                        <td style='padding:0in 5.4pt 0in 5.4pt;' width=350px><strong>Pure and Soft Water LLC</strong></td>
                        <td style='padding:0in 5.4pt 0in 5.4pt;' width=400px>78926 Melody Lane, Hermiston, OR 97838</td>
                        <td style='padding:0in 5.4pt 0in 5.4pt;'width=400px>541-567-1136</td>
                    </tr>
                    <tr style='background-color: #F2F2F2;'>
                        <td style='padding:0in 5.4pt 0in 5.4pt;'width=350px><strong>Hellman Plumbing </strong></td>
                        <td style='padding:0in 5.4pt 0in 5.4pt;' width=400px>639 NE Dakota Ct., Hermiston, Oregon</td>
                        <td style='padding:0in 5.4pt 0in 5.4pt;'width=400px>541-321-0056</td>
                    </tr>
                </table>
            </div>
        </body> 
    </section>

    <!-- Spanish -->
    <section>
        <span class="page-break"></span>
        <Header>
            <img src="{{environment.baseUrl}}/assets/images/OregonWell_Letterheader.png" alt="Letter Header" width="100%">
        </Header>
        <style>
            td,
            th {
                border: 1px solid #dddddd;
                margin-left: 5.4pt;
                padding: 0in 5.4pt 0in 5.4pt
            }
        </style>

        <body class="spanish-text">
            <p style='color:green; '>{{voucher?.applicantContactName}}<br>
                {{voucher?.applicantAddress}}<br>
                {{voucher?.applicantCity}} {{voucher?.applicantState}} {{voucher?.applicantZip}}</p>
            <p></p>
            <p></p>
            <p >Saludos</p>

            <p >En este documento, encontrará su comprobante para el tratamiento del agua y los
                próximos pasos a seguir.</p>

            <p ><strong class="spanish-text-bold">Encuentre un especialista en tratamiento o un plomero con
                    licencia</strong><br>
                Elija un especialista en tratamiento o un plomero con licencia en la siguiente página de este documento.
                Comuníquese con el especialista en tratamiento y programe los servicios de tratamiento del agua.</p>

            <p ><strong class="spanish-text-bold">Presente el comprobante al especialista en tratamiento o plomero</strong><br>
                El especialista en tratamiento o plomero instalará un sistema de tratamiento de ósmosis inversa (reverse
                osmosis, RO) certificado debajo del fregadero de su cocina para reducir los niveles de nitratos por
                debajo de los 10 miligramos por litro (mg/l).</p>

            <p ><strong class="spanish-text-bold">Recordatorio:</strong> El comprobante no es transferible. Si elige no usar
                el comprobante, contáctenos a <a
                    href="mailto:Domestic.Wells@odhsoha.oregon.gov"><u>Domestic.Wells@odhsoha.oregon.gov</u></a> o llame
                al 541-952-9254.</p>

            <p>

                <br>
                <strong>_ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _
                    <br>
                    <br>
                </strong>
            </p>
            <div style="page-break-before: always; " class="page-break">
                <strong >Comprobante</strong>
                <table border=1 cellspacing=0 cellpadding=0 width=1100px
                    style='padding:0in 5.4pt 0in 5.4pt;margin-left:5.4pt;border-collapse:collapse;border:none;'
                    aria-describedby="voucher">
                    <tr>
                        <th scope="col" width=400px valign=top
                            style='border:solid black 1.0pt;background:black;padding:0in 5.4pt 0in 5.4pt;color:white;'>
                            Elemento</th>
                        <th scope="col" width=700px valign=top
                            style='border:solid black 1.0pt;border-left:none;background:black;padding:0in 5.4pt 0in 5.4pt;color:white;'>
                            Detalles del comprobante</th>
                    </tr>
                    <tr>
                        <td style='padding:0in 5.4pt 0in 5.4pt;' width=400px >Nombre del cliente</td>
                        <td style='padding:0in 5.4pt 0in 5.4pt;color:green' width=700px><p>{{voucher?.applicantContactName}}</p></td>
                    </tr>
                    <tr>
                        <td style='padding:0in 5.4pt 0in 5.4pt;' width=400px >Número de comprobante</td>
                        <td style='padding:0in 5.4pt 0in 5.4pt;color:green' width=700px><p>{{voucher?.voucherId}}</p></td>
                    </tr>
                    <tr>
                        <td style='padding:0in 5.4pt 0in 5.4pt;' width=400px >Dirección del solicitante</td>
                        <td style='padding:0in 5.4pt 0in 5.4pt;color:green' width=700px>
                            <p>{{voucher?.applicantAddress}}<br>
                                {{voucher?.applicantCity}} {{voucher?.applicantState}} {{voucher?.applicantZip}}</p>
                        </td>
                    </tr>
                    <tr>
                        <td style='padding:0in 5.4pt 0in 5.4pt;' width=400px >Dirección del pozo<br>
                            <small>(si es diferente a la dirección postal)</small>
                        </td>
                        <td style='padding:0in 5.4pt 0in 5.4pt;color:green' width=700px>
                            <p *ngIf="wellAddressDifferent">{{voucher?.well?.address1}}<br>
                                {{voucher?.well?.city}} {{voucher?.well?.state}} {{voucher?.well?.zip}}</p>
                        </td>
                    </tr>
                    <tr>
                        <td valign=top style='padding:0in 5.4pt 0in 5.4pt;' width=400px >Elementos incluidos en
                            el tratamiento:</td>
                        <td style='padding:0in 5.4pt 0in 5.4pt;color:green' width=700px>
                            <p>
                                1 sistema de tratamiento por ósmosis inversa para la reducción de nitratos (certificado), 2
                                membranas de reemplazo del sistema de ósmosis inversa, 2 prefiltros de reemplazo, 2
                                posfiltros de reemplazo, 1 test para la medición de nitratos posterior al tratamiento.
                                Según sea necesario: Bomba elevadora de presión, filtro para el tratamiento posterior a la
                                reducción de nitratos, test adicional para la medición de nitratos (si se instala un filtro
                                para el tratamiento posterior a la reducción de nitratos).<br />
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td style='padding:0in 5.4pt 0in 5.4pt;' width=400px >El valor total no debe exceder</td>
                        <td style='padding:0in 5.4pt 0in 5.4pt;' width=700px ><strong class="spanish-text-bold"><p>$2,950.00</p></strong></td>
                    </tr>
                </table>


                <br /><br />
                <span >&nbsp;&nbsp;Especialistas en tratamiento y plomeros con licencia
                    contratados</span>
                <br /> <br />
                <table border=1 cellspacing=0 cellpadding=0 width=1100px  aria-describedby="accreditedLabs">
                    <tr style='height:15.0pt'>
                        <th scope="col" width=350px ><strong class="spanish-text-bold">Nombre del contratista
                                especializado en tratamiento</strong></th>
                        <th scope="col" width=400px><span>Direcció n</span></th>
                        <th scope="col" width=400px ><span class="spanish-text">Telefono</span></th>
                    </tr>
                    <tr style='background-color: #F2F2F2;'>
                        <td style='padding:0in 5.4pt 0in 5.4pt;' width=350px ><strong class="spanish-text-bold">Pure and Soft Water LLC</strong></td>
                        <td style='padding:0in 5.4pt 0in 5.4pt;' width=400px >78926 Melody Lane, Hermiston, OR 97838</td>
                        <td style='padding:0in 5.4pt 0in 5.4pt;' width=400px >541-567-1136</td>
                    </tr>
                    <tr style='background-color: #F2F2F2;'>
                        <td style='padding:0in 5.4pt 0in 5.4pt;' width=350px ><strong class="spanish-text-bold">Hellman Plumbing </strong></td>
                        <td style='padding:0in 5.4pt 0in 5.4pt;' width=400px >639 NE Dakota Ct., Hermiston, Oregon</td>
                        <td style='padding:0in 5.4pt 0in 5.4pt;' width=400px >541-321-0056</td>
                    </tr>
                </table>
            </div>
        </body> 
    </section>
    </ng-template>
</mat-dialog-content>